module.exports = __webpack_public_path__ + "static/media/jccw-logo.f0a9e8ac.svg";